<template>
  <div>
    <b-table
      :key="stateKey"
      hover
      small
      caption-top
      responsive="sm"
      :items="items"
      :fields="columns">
      <!-- IF THE FOLLOW SLOT IS NOT SHOWING, LOOK FOR FAULTY LOGIC IN "COLUMNS" COMPUTED -->
        <template #cell(guests)="{item: {guests, justifications}, item}">
          <div @click="$emit('clicked-guest-statistics', item)" class="flex flex-row gap-2 __guest-statistics">
            <b
              v-if="_.isArray(guests)"
              class="text-success"
              v-tooltip="{
                delay: {show: 10, hide: 10},
                content: $tc('guests_confirmed', guests.length, [guests.length])
              }"
            >
              {{guests.length}}
            </b>

            <b
              v-if="_.isArray(justifications) && justifications.length > 0"
              class="text-danger"
              v-tooltip="{
                delay: {show: 10, hide: 10},
                content: $tc('guests_rejected', justifications.length, [justifications.length])
              }"
            >
              {{justifications.length}}
            </b>

          </div>
        </template>

        <template #cell(action)="{item, index}">
          <feather-icon
            v-if="canRemove"
            @click="actionEvent('clicked-remove', item)"
            icon="XCircleIcon"
            size="21"
            class="h-5 w-5 mr-3 stroke-current text-danger cursor-pointer"
          />
          <template v-if="withinDate(item.start_at, item.finish_at)">
            <b-button
              v-if="!isScheduled(item) && canParticipate && item.id && !anyConfirmed"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-success"
              @click="actionEvent('clicked-confirm', item, index)"
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-50"
              />
              <span class="align-middle">Confirmar</span>
            </b-button>

            <b-button
              v-if="isScheduled(item)"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-warning"
              @click="actionEvent('clicked-disconfirm', item, index)"
            >
              <feather-icon
                icon="XCircleIcon"
                class="mr-50"
              />
              <span class="align-middle">Desmarcar</span>
            </b-button>
          </template>
        </template>
    </b-table>
    <slot name="after"/>
  </div>
</template>

<script>
import {
  BTable,
  BButton
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'


export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    canRemove: {
      type: Boolean,
      default: false
    },
    canParticipate: {
      type: Boolean,
      default: false
    },
    /**
     * The name of this prop appears tricky,
     * it's just a workaround for showing change when a non-reactive
     * value is changed, as is done in the handlers of the clicked events
     * that are defined in the most important parent of this component,
     * which is CalendarEventHandler.vue
     */
    reRenderOnActions: {
      type: Boolean,
      default: false
    },
    showGuestStatistics: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BTable,
    BButton,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    stateKey: 0, // Used for forcing the component to re-render when updated.
  }),
  computed: {
    columns() {
      const fields = [
        { key: 'start_at_formatted', label: 'Data Início' },
        { key: 'finish_at_formatted', label: 'Data Fim' }
      ]

      if (this.showGuestStatistics) {
        fields.push({ key: 'guests', label: 'Convidados'})
      }

      fields.push({ key: 'action', label: 'Ação' })

      return fields
    },
    anyConfirmed() {
      if ( this.items.length > 0) {
        return this._.some(this.items, 'scheduled')
      } else return false
    },
  },
  methods: {
    actionEvent(event, ...params) {
      this.$emit(event, ...params)
      if (this.reRenderOnActions) setTimeout(() => this.stateKey++, 100)
    },
    withinDate(start, finish) {
      const startDate = this.$moment(start)
      const finishDate = this.$moment(finish)
      const nowDate = this.$moment()

      return nowDate.isBefore(finishDate)
    },
    isScheduled(scheduleSuggestion) {

      if (!this.isEmpty(scheduleSuggestion.scheduled)) {
        return scheduleSuggestion.scheduled
      }

      return scheduleSuggestion.guests && scheduleSuggestion.guests.length > 0
    },
  }
}
</script>

<style lang="scss">
.__guest-statistics {
  width: min-content;
  @apply rounded;
  @apply border bg-faint-grey border-grey border-solid px-2;
  &:hover {
    @apply bg-grey;
  }
}
</style>